













































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/header.vue";
import { changeAdminPassword } from "@/req/account";
@Component({
  components: {
    headerTitle,
  },
})
export default class Home extends Vue {
  public formInline = {
    old_password: "",
    new_password: "",
    re_new_password: "",
  };
  public smsCount = "获取验证码";
  public countdown = 60;
  public timer: any = "";
  public smsCountTime = false;
  public isDisable = false;
  public ruleInline = {
    old_password: [
      { required: true, message: "请输入旧密码", trigger: "blur" },
    ],
    new_password: [
      {
        required: true,
        // message: "请输入正确密码",
        validator: this.validatePassWord,
        trigger: "blur",
      },
    ],
    re_new_password: [
      {
        required: true,
        // message: "请输入正确密码",
        validator: this.validatePassCheck,
        trigger: "blur",
      },
    ],
  };
  // 密码验证
  public validatePassWord(rule, value, callback) {
    const s = /^[0-9a-zA-Z]*$/g;
    const p = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,20}$/;
    if (!p.test(value)) {
      callback(new Error("密码必须包含字母和数字"));
    } else if (!s.test(value)) {
      callback(new Error("只允许输入字母和数字"));
    } else if (value.length < 8) {
      callback(new Error("密码长度不能小于8位"));
    } else {
      callback();
    }
  }
  // 确认密码验证
  public validatePassCheck(rule, value, callback) {
    if (value === "") {
      callback(new Error("密码不能为空"));
    } else if (value !== this.formInline.new_password) {
      callback(new Error("两次输入密码不符"));
    } else {
      callback();
    }
  }
  public clearBlank(val) {
    // 空格回退
    this.formInline[`${val}`] = this.formInline[`${val}`].replace(/[, ]/g, "");
    // 不允许输入中文
    this.formInline[`${val}`] = this.formInline[`${val}`].replace(
      /[\u4e00-\u9fa5]/gi,
      ""
    );
    // 不允许输入特殊符号
    this.formInline[`${val}`] = this.formInline[`${val}`].replace(
      /[^\w\u4E00-\u9FA5]/g,
      ""
    );
  }
  // 手机号校验
  // public async getVerify() {
  //   const res = await checkPhone({
  //     token: this.$fn.cookies.getToken("token"),
  //     phone: this.formInline.phone,
  //   });
  //   if (res.code === 200) {
  //     this.gain();
  //   }
  // }
  // 获取手机验证码
  // public async gain() {
  //   this.smsCountDown();
  //   this.smsCountTime = true;
  //   const obj = {
  //     token: this.$fn.cookies.getToken("token"),
  //     phone: this.formInline.phone,
  //   };
  //   const res = await PhoneCode(obj);
  //   // if (res.code == 200) {
  //   //   this.smsCountTime = false;
  //   // }
  // }
  // 短信验证码倒计时
  public smsCountDown() {
    const self = this;
    this.timer = setInterval(() => {
      self.countdown--;
      if (self.countdown === 0) {
        clearInterval(self.timer);
        self.countdown = 60;
        self.smsCountTime = false;
      }
    }, 1000);
  }
  // 提交验证
  public confirm(name) {
    this.isDisable = true;
    setTimeout(() => {
      this.isDisable = false;
    }, 3000);
    (this.$refs[name] as any).validate((valid) => {
      if (valid) {
        this.handleSubmitClick();
      } else {
        this.$Message.error("请输入正确的格式!");
      }
    });
  }
  public async handleSubmitClick() {
    // this.$Message.success("ok")
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      old_password: this.formInline.old_password,
      new_password: this.formInline.new_password,
      re_new_password: this.formInline.re_new_password,
    };
    const res = await changeAdminPassword(obj);
    if (res.code == 200) {
      this.$router.push("/login");
      this.$Message.success(res.msg);
    }
  }
}
